module.exports = __webpack_public_path__ + "media/images/macys-logo-3c0fd9f26afb8735ee525595f4ecec62.png";